import { useCallback } from 'react'
import { chatWidgetStore } from 'shared/stores/chatWidgetStore'
import { researchSessionStore } from 'shared/stores/researchSessionStore'
import { buildKodaContext } from 'widgets/ChatWidget/kodaContext'

function buildResearchKodaContext() {
	const studentId = researchSessionStore.selectedStudentId

	return buildKodaContext({
		source: 'counselor_research',
		subject: studentId ? { studentId: String(studentId) } : undefined,
	})
}

/**
 * Opens Koda chat and auto-sends a prompt with Research page + student context.
 * Career/country/course details live in the prompt text; kodaContext only carries
 * allowed envelope keys (source + subject) per API contract.
 */
export function useResearchKodaChat() {
	const sendPrompt = useCallback(text => {
		const message = String(text || '').trim()
		if (!message) {
			chatWidgetStore.open()
			return
		}

		chatWidgetStore.openWithPrompt({
			text: message,
			kodaContext: buildResearchKodaContext(),
		})
	}, [])

	return { sendPrompt }
}
